export interface GetFilterQueryString<T> {
  filter: T
}

export const getFilterQueryString = <
  T extends Record<string, string | number | boolean | null | undefined>,
>({
  filter,
}: GetFilterQueryString<T>): string =>
  filter
    ? Object.entries(filter).reduce(
        (res, [key, value]) =>
          value === null || value === undefined
            ? res
            : `${res}&filter[${key}]=${encodeURIComponent(value)}`,
        '',
      )
    : ''
